import { ReactComponent as DemoLink } from "./../assets/svgs/demo-link.svg";
import { ReactComponent as BlogsLink } from "./../assets/svgs/blogs-link.svg";
import { ReactComponent as GetStartedLink } from "./../assets/svgs/get-started-link.svg";
import { ReactComponent as IntegrationLink } from "./../assets/svgs/integration-link.svg";
import { ReactComponent as SolutionsLink } from "./../assets/svgs/solutions-link.svg";

const ICON_WRAP =
  "w-[48px] h-[48px] text-[#7A7A7A] transition-colors duration-300 ease-in-out group-hover:text-white";

const LinkIcon = ({ Icon }) => {
  const Fallback = BlogsLink;
  const Comp = Icon || Fallback;

  return (
    <span className={ICON_WRAP} aria-hidden="true">
      <Comp className="w-full h-full" />
    </span>
  );
};

const QuickLinksSection = ({contactSource=""}) => {
  const links = [
    { label: "DEMO", href: "/demo", Icon: DemoLink },
    { label: contactSource === "AiSizing" ? "PRODUCTS" : contactSource === "virtual-try-on" ? "SHOPIFY CONNECTIVITY" : "SOLUTIONS", href: contactSource === "virtual-try-on" ? "/integration" : "/solutions", Icon: SolutionsLink },
    { label: contactSource === "AiSizing" ? "SHOPIFY CONNECTIVITY" : contactSource === "virtual-try-on" ? "PRODUCTS" : "INTEGRATION", href: contactSource === "virtual-try-on" ? "/solutions" : "/integration", Icon: IntegrationLink },
    { label: "GET STARTED", href: "/get-started", Icon: GetStartedLink },
    { label: "BLOGS", href: "/blog", Icon: BlogsLink },
  ];

  return (
    <section className="pb-[60px]">
      <div className="grid grid-cols-2 md:grid-cols-5 gap-6 md:px-[65px]">
        {links.map((l) => (
          <div key={l.label} className="group flex flex-col items-center">
            {/* Box */}
            <a
              href={l.href}
              className="w-full bg-[#F7F3F0] rounded-[6px] border border-[#EFE7E1] h-[92px] md:h-[110px] flex items-center justify-center transition-colors duration-300 ease-in-out hover:bg-black hover:border-black"
              aria-label={l.label}
            >
              <LinkIcon Icon={l.Icon} />
            </a>

            {/* Text below the box */}
            <div className="mt-3 text-[9px] tracking-[0.18em] text-[#7A7A7A] transition-colors duration-300 ease-in-out group-hover:text-black font-inter">
              {l.label}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default QuickLinksSection;
